import "./ScaffoldingInFarnborough.module.css";
import Header from "@/reusable_sections/Header";
import Farnborough from "./sections/Farnborough";
import SafetyAccess from "./sections/SafetyAccess";
import Faq from "./sections/Faq";
import QuoteCTA from "./sections/QuoteCTA";
import Footer from "@/reusable_sections/Footer";
export default function ScaffoldingInFarnboroughPage() {
  return <div>
      <Header />
      <Farnborough />
      <SafetyAccess />
      <Faq />
      <QuoteCTA />
      <Footer />
    </div>;
}